import { Viewport, ViewportId } from "./types";

/**
 * This module is included as part of the `yarn build:css` build process and changes to it will affect the output of `stylesheet.compiled.ts`.
 * You must run `yarn build:css` after any changes here as the build will fail if `stylesheet.compiled.ts` changes on CI.
 */

export const viewports = {
  small: 480,
  medium: 768,
  large: 960,
  xlarge: 1200,
  xxlarge: 1800,
  max: 1800,
};

export const queries: Record<ViewportId, Required<Viewport>> = {
  xsmall: {
    min: 0,
    max: viewports.small - 1,
  },
  small: {
    min: viewports.small,
    max: viewports.medium - 1,
  },
  medium: {
    min: viewports.medium,
    max: viewports.large - 1,
  },
  large: {
    min: viewports.large,
    max: viewports.xlarge - 1,
  },
  xlarge: {
    min: viewports.xlarge,
    max: viewports.xxlarge - 1,
  },
  xxlarge: {
    min: viewports.xxlarge,
    max: Number.MAX_SAFE_INTEGER, // can't use Infinity in CSS
  },
};
